import * as React from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

interface Props {
  onNext: (mediaProjectType: MediaProjectType) => void;
}

export enum MediaProjectType {
  TRANSCRIPTION = "TRANSCRIPTION",
  TRANSCRIPTION_AND_TRANSLATION = "TRANSCRIPTION_AND_TRANSLATION",
  DUBBING = "DUBBING",
  EMBEDDING_TRANSLATED_SUBTITLES_INTO_SOURCE_VIDEO = "EMBEDDING_TRANSLATED_SUBTITLES_INTO_SOURCE_VIDEO"
}

const SelectProjectTypeStep: React.FC<Props> = ({ onNext }) => {
  const { t } = useTranslation();

  const projectTypes = [
    {
      type: MediaProjectType.TRANSCRIPTION,
      title: t("machineTranslation.mediaTranslation.projectTypes.transcription.title"),
      description: t("machineTranslation.mediaTranslation.projectTypes.transcription.description")
    },
    {
      type: MediaProjectType.TRANSCRIPTION_AND_TRANSLATION,
      title: t("machineTranslation.mediaTranslation.projectTypes.transcriptionAndTranslation.title"),
      description: t("machineTranslation.mediaTranslation.projectTypes.transcriptionAndTranslation.description")
    },
    {
      type: MediaProjectType.DUBBING,
      title: t("machineTranslation.mediaTranslation.projectTypes.dubbing.title"),
      description: t("machineTranslation.mediaTranslation.projectTypes.dubbing.description")
    },
    {
      type: MediaProjectType.EMBEDDING_TRANSLATED_SUBTITLES_INTO_SOURCE_VIDEO,
      title: t("machineTranslation.mediaTranslation.projectTypes.embeddingSubtitles.title"),
      description: t("machineTranslation.mediaTranslation.projectTypes.embeddingSubtitles.description")
    }
  ];
  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Typography variant="h6" component="h3" sx={{ fontWeight: 500, color: "primary.main" }}>
        {t("machineTranslation.mediaTranslation.projectTypes.prompt.title")}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t("machineTranslation.mediaTranslation.projectTypes.prompt.description")}
      </Typography>
      {projectTypes.map(project => (
        <Button
          key={project.type}
          onClick={() => onNext(project.type)}
          variant="outlined"
          sx={{
            p: 3,
            textAlign: "left",
            display: "block",
            minHeight: "100px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)"
            }
          }}
        >
          <Typography variant="subtitle1" component="div" sx={{ fontWeight: "bold", mb: 1 }}>
            {project.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4, textTransform: "none" }}>
            {project.description}
          </Typography>
        </Button>
      ))}
    </Stack>
  );
};

export { SelectProjectTypeStep };
